<template>
  <div
    class="tw-flex tw-items-center tw-py-6 tw-gap-6 hover:tw-bg-light dark:hover:tw-bg-dm-light tw-px-6"
  >
    <div
      class="tw-flex tw-items-center"
      :style="`width: ${columns[0].width}`"
    >
      <i-user-avatar
        :avatar="user.avatar_url && user.avatar_url['128'] && `${$baseHost}/${user.avatar_url['128']}`"
        :fullname="user.fullname"
        size="small"
        class="tw-mr-3"
      />
    </div>

    <div :style="`width: ${columns[1].width}`">
      <i-badge
        :type="user.is_active ? 'success' : 'default'"
        class="tw-w-fit"
      >
        {{ user.is_active ? $t('common.values.yes') : $t('common.values.no') }}
      </i-badge>
    </div>

    <div
      class="tw-leading-5 tw-tracking-normal"
      :style="`width: ${columns[2].width}`"
    >
      {{ user.fullname }}
    </div>

    <div
      class="tw-leading-5 tw-tracking-normal"
      :style="`width: ${columns[3].width}`"
    >
      <div class="tw-flex tw-flex-col tw-gap-1.5">
        <a :href="`mailto:${user.email}`">{{ user.email }}</a>
        <a :href="`tel:${user.phone_primary}`">{{ user.phone_primary }}</a>
      </div>
    </div>

    <div :style="`width: ${columns[4].width}`">
      {{ user.last_login }}
    </div>

    <div :style="`width: ${columns[5].width}`">
      <div
        class="tw-flex tw-items-center tw-gap-2"
      >
        <i-button
          type="white"
          is-icon
          @click="isEditCompanyDialogOpen = true"
        >
          <icon-edit />
        </i-button>
        <i-confirm-popover
          :cancel-text="$t('common.actions.cancel')"
          :submit-text="$t('common.actions.delete')"
          @submit="deleteUser"
        >
          <template #reference>
            <i-button
              type="white"
              is-icon
              class="tw-text-primary"
              :is-loading="isDeleting"
            >
              <icon-trash />
            </i-button>
          </template>
          <template #content>
            <div>
              {{ $t('adm.users.delete_confirmation', { userName }) }}
            </div>
          </template>
        </i-confirm-popover>
      </div>
    </div>
    <EditInternalUserDialog
      :is-open="isEditCompanyDialogOpen"
      :user-id="user.id"
      @close="isEditCompanyDialogOpen = false"
    />
  </div>
</template>

<script>

import EditInternalUserDialog from '@/components/Administration/Internal/Users/EditInternalUserDialog.vue';
import { getValidationError } from '@/helpers';

export default {
  name: 'InternalUsersListItem',
  components: { EditInternalUserDialog },
  props: {
    user: {
      type: Object,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isEditCompanyDialogOpen: false,
      isDeleting: false,
    };
  },
  computed: {
    userName() {
      if (this.user.fullname != null && this.user.fullname !== '') {
        return this.user.fullname;
      }
      return `${this.user.first_name} ${this.user.last_name}`;
    },
  },

  methods: {
    async deleteUser() {
      this.isDeleting = true;
      try {
        await this.$store.dispatch('v2/admin/cms/internal/users/deleteUser', this.user.id);
      } catch (e) {
        const errorText = getValidationError(e);

        this.$message.error({
          message: errorText,
          showClose: true,
          dangerouslyUseHTMLString: true,
        });
      } finally {
        this.isDeleting = false;
      }
    },
  },
};
</script>
